import { Observable } from 'rxjs';
import { AnexoContratoResponse } from 'src/app/global/interfaces/anexo-contrato-response';

export abstract class AnexoContratoServiceVM {

    abstract getAnexoContrato(): Observable<any>;

    abstract getEstadoAnexos(): Observable<AnexoContratoResponse>;

    abstract postApruebaDocumento(data: any): Observable<any>;

    abstract postApruebaDocPromise(data: any): Promise<any>;

    abstract postAprobarAnexoContratoComercio(): Observable<any>;

    abstract postAprobarAnexoContratoRepresentante(): Observable<any>;

    abstract getTipoAprobacion(): Observable<any>;

    abstract getPreviewDocumento(): Observable<any>;

    // abstract aceptarTerminos(data: any): Observable<any>;

    abstract obtenerAnexoContrato(): Promise<any>;

    abstract aprobarAnexo(data: any): Promise<any>;

}
